import { ErrorTrackingClient } from "@squareup/service-error-tracking";
import { isDevelopmentEnvironment, getEnvironment } from "@squareup/util-environment";
const CASH_LOCAL_SELLER_SENTRY_DSN = "https://b6f260c26cf399efd32aaf48a01a0809@o160250.ingest.us.sentry.io/4509991002636288";
const client = new ErrorTrackingClient({
  environment: getEnvironment(),
  dsn: CASH_LOCAL_SELLER_SENTRY_DSN,
  release: isDevelopmentEnvironment() ? "" : globalThis.process?.env?.GIT_COMMIT || ""
});
export {
  client as default
};
//# sourceMappingURL=error-tracking-client.js.map
